import { Box, Typography } from '@mui/material'
import React from 'react'

const BusRoute = ({ bkgDeatails }) => {

    let routeList = bkgDeatails?.routeCity || []

    return (
        <>
            <Box className='route_details'>
                {routeList?.map((obj, index) => (
                    <Typography key={index} >
                        <span
                            className={`${obj.CityID === bkgDeatails?.tripDetails?.FromCityID ? 'fromVaiCity' : obj.CityID === bkgDeatails?.tripDetails?.ToCityID ? 'toVaiCity' : ''}`}
                        >{obj.cityname}</span>
                        {index !== routeList.length - 1 && " → "}
                    </Typography>
                ))}
            </Box>
        </>
    )
}

export default BusRoute